export const TABLE_COLUMN_MOVED = 'table/COLUMN_MOVED';
export const columnMoved = (tableName, columns) => ({
  type: TABLE_COLUMN_MOVED,
  payload: {
    tableName,
    columns,
  },
});

export const TABLE_COLUMNS_CHANGED = 'table/TABLE_COLUMNS_CHANGED';
export const columnsChanged = (tableName, columns) => ({
  type: TABLE_COLUMNS_CHANGED,
  payload: {
    tableName,
    columns,
  },
});

export const getColumnsChangedAction = tableName => columns =>
  columnsChanged(tableName, columns);
